import apiClient from '../utils/apiClient';

/**
 * Modifier Group API Services
 * Quản lý nhóm tùy chọn (kích cỡ, đá, đường, topping)
 */

const mapOptionsPayload = (options = []) =>
  options.map((option) => {
    const payload = {};
    if (option.id !== undefined) payload.id = option.id;
    if (option.name !== undefined) payload.name = option.name;
    if (option.price !== undefined) payload.price = option.price;
    if (option.isDefault !== undefined) payload.is_default = option.isDefault;
    if (option.displayOrder !== undefined) payload.display_order = option.displayOrder;
    return payload;
  });

const buildModifierGroupPayload = (data = {}) => {
  const payload = {};
  if (data.name !== undefined) payload.name = data.name;
  if (data.type !== undefined) payload.type = data.type;
  if (data.required !== undefined) payload.required = data.required;
  if (data.displayOrder !== undefined) payload.display_order = data.displayOrder;
  if (data.isActive !== undefined) payload.is_active = data.isActive;
  if (data.options !== undefined) payload.options = mapOptionsPayload(data.options);
  return payload;
};

export const modifierGroupAPI = {
  /**
   * Lấy danh sách nhóm tùy chọn
   * @returns {Promise<Object>} Danh sách nhóm tùy chọn
   */
  getModifierGroups: async () => {
    return await apiClient.get({
      url: '/modifier-groups',
    });
  },

  /**
   * Lấy thông tin chi tiết nhóm tùy chọn
   * @param {string} groupId - ID nhóm tùy chọn
   * @returns {Promise<Object>} Thông tin chi tiết nhóm tùy chọn
   */
  getModifierGroupById: async (groupId) => {
    return await apiClient.get({
      url: `/modifier-groups/${groupId}`,
    });
  },

  /**
   * Tạo nhóm tùy chọn mới
   * @param {Object} groupData - Dữ liệu nhóm tùy chọn
   * @param {string} groupData.name - Tên nhóm
   * @param {string} groupData.type - Loại ('single' hoặc 'multiple')
   * @param {boolean} groupData.required - Bắt buộc chọn
   * @param {Array<Object>} groupData.options - Danh sách tùy chọn
   * @param {number} groupData.displayOrder - Thứ tự hiển thị
   * @param {boolean} groupData.isActive - Trạng thái hoạt động
   * @returns {Promise<Object>} Thông tin nhóm tùy chọn vừa tạo
   */
  createModifierGroup: async (groupData) => {
    return await apiClient.post({
      url: '/modifier-groups',
      data: buildModifierGroupPayload(groupData),
    });
  },

  /**
   * Cập nhật thông tin nhóm tùy chọn
   * @param {string} groupId - ID nhóm tùy chọn
   * @param {Object} updateData - Dữ liệu cập nhật
   * @returns {Promise<Object>} Thông tin nhóm tùy chọn sau khi cập nhật
   */
  updateModifierGroup: async (groupId, updateData) => {
    return await apiClient.put({
      url: `/modifier-groups/${groupId}`,
      data: buildModifierGroupPayload(updateData),
    });
  },

  /**
   * Xóa nhóm tùy chọn
   * @param {string} groupId - ID nhóm tùy chọn
   * @returns {Promise<Object>} Kết quả xóa
   */
  deleteModifierGroup: async (groupId) => {
    return await apiClient.delete({
      url: `/modifier-groups/${groupId}`,
    });
  },

  /**
   * Sắp xếp lại thứ tự nhóm tùy chọn
   * @param {Array<string>} modifierGroupIds - Mảng ID nhóm tùy chọn theo thứ tự mới
   * @returns {Promise<Object>} Kết quả sắp xếp
   */
  reorderModifierGroups: async (modifierGroupIds) => {
    return await apiClient.patch({
      url: '/modifier-groups/reorder',
      data: { modifier_group_ids: modifierGroupIds },
    });
  },
};
